import React from 'react';
import ReactDOM from 'react-dom/client';
import { ForBrand } from './ForBrand';
import type { Athletes, CtaBlock, Hero, HowItWorks } from './slides';

type PageData = {
    csrfToken: string;
    hero: Hero;
    athletes: Athletes;
    howItWorks: HowItWorks;
    ctaBlock: CtaBlock;
};

const pageDataEl = document.getElementById('pageData');
if (!pageDataEl) { throw new Error('Missing #pageData element'); }
const pageData: PageData = JSON.parse(pageDataEl.textContent!);

const container = document.getElementById('for-brand-root');
if (!container) { throw new Error('Missing #for-brand-root element'); }
const root = ReactDOM.createRoot(container);
root.render(React.createElement(ForBrand, pageData));

if (module.hot) { module.hot.accept(); }
